/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Usecases_Item_4_ProblemInputs */

const es_home_usecases_item_4_problem = /** @type {(inputs: Home_Usecases_Item_4_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prepararse para una reunión requiere buscar manualmente emails, documentos y notas.`)
};

const en_home_usecases_item_4_problem = /** @type {(inputs: Home_Usecases_Item_4_ProblemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparing for a meeting requires manually searching emails, documents, and notes.`)
};

/**
* | output |
* | --- |
* | "Preparing for a meeting requires manually searching emails, documents, and notes." |
*
* @param {Home_Usecases_Item_4_ProblemInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_usecases_item_4_problem = /** @type {((inputs?: Home_Usecases_Item_4_ProblemInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Usecases_Item_4_ProblemInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_usecases_item_4_problem(inputs)
	return en_home_usecases_item_4_problem(inputs)
});
export { home_usecases_item_4_problem as "home.usecases.item_4_problem" }